function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
var PREFIX = 'BrandOverlay';
var classes = {
  modal: "".concat(PREFIX, "-modal"),
  paper: "".concat(PREFIX, "-paper"),
  closeIcon: "".concat(PREFIX, "-closeIcon"),
  titleContainer: "".concat(PREFIX, "-titleContainer"),
  closeButton: "".concat(PREFIX, "-closeButton"),
  loadingOverlay: "".concat(PREFIX, "-loadingOverlay")
};
var StyledDialog = styled(Dialog)(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "&.".concat(classes.modal), {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiDialog-paper': {
      maxWidth: '800px',
      backgroundColor: 'transparent'
    }
  }), "& .".concat(classes.paper), _defineProperty({
    background: theme.palette.content.primary,
    borderRadius: '.5px',
    fontWeight: 400,
    color: theme.palette.font.primary,
    padding: '16px 24px',
    width: '600px'
  }, theme.breakpoints.down('sm'), {
    width: '100%'
  })), "& .".concat(classes.closeIcon), {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    color: theme.palette.font.primary
  }), "& .".concat(classes.titleContainer), {
    background: theme.palette.title.primary,
    borderBottom: theme.palette.title.border,
    fontWeight: '700',
    color: theme.palette.font.tertiary,
    fontSize: '18px'
  }), "& .".concat(classes.closeButton), {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }), "& .".concat(classes.loadingOverlay), {
    display: 'flex',
    zIndex: 99999999,
    height: '100%',
    width: '100%',
    position: 'absolute',
    color: 'white',
    background: 'rgba(0, 0, 0, 0.2)',
    alignItems: 'center',
    justifyContent: 'center'
  });
});
var loadingIcon = /*#__PURE__*/React.createElement("i", {
  className: "fa fa-spinner fa-spin fa-lg fa-fw fl-loading"
});
var LoadingOverlay = function LoadingOverlay() {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.loadingOverlay
  }, loadingIcon);
};
var BrandOverlay = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var onClose = _ref3.onClose,
    children = _ref3.children,
    title = _ref3.title,
    contentStyle = _ref3.contentStyle,
    isRequesting = _ref3.isRequesting,
    args = _ref3.args,
    _ref3$noTitle = _ref3.noTitle,
    noTitle = _ref3$noTitle === void 0 ? false : _ref3$noTitle;
  return /*#__PURE__*/React.createElement(StyledDialog, _extends({
    open: true,
    ref: ref,
    className: classes.modal,
    onClose: onClose,
    disableEnforceFocus: true,
    disableAutoFocus: true
  }, args), isRequesting && /*#__PURE__*/React.createElement(LoadingOverlay, null), !noTitle && /*#__PURE__*/React.createElement(DialogTitle, {
    className: classes.titleContainer
  }, title, onClose && /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "close",
    className: classes.closeButton,
    onClick: onClose,
    size: "large"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    className: classes.closeIcon
  }))), /*#__PURE__*/React.createElement(DialogContent, {
    dividers: true,
    className: classes.paper,
    style: contentStyle
  }, children));
});
BrandOverlay.displayName = 'BrandOverlay';
BrandOverlay.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  contentStyle: PropTypes.object,
  isRequesting: PropTypes.bool,
  noTitle: PropTypes.bool,
  args: PropTypes.object
};
export default BrandOverlay;